import { AVAILABLE_WORLDS } from '../languages/constants';

type Record = {
    [key: string]: string;
};

type NestedRecords<T> = {
    [key: string]: T;
};

export const aiHelpCenter: Record = {
    de: 'https://help.eduki.com/hc/de/articles/20659689712786-Wie-funktioniert-das-neue-KI-Feature-im-Uploader'
};

export const contactEmails: Record = {
    de: 'hallo@eduki.com',
    es: 'hola@eduki.com',
    fr: 'salut@eduki.com',
    gr: 'hellogreece@eduki.com',
    it: 'ciao@eduki.com'
};

export const helpCenter: Record = {
    de: 'https://help.eduki.com/hc/de',
    es: 'https://help.eduki.com/hc/es',
    fr: 'https://help.eduki.com/hc/fr',
    gr: 'https://help.eduki.com/hc/el',
    it: 'https://help.eduki.com/hc/it',
    ...Object.values(AVAILABLE_WORLDS)
        .filter((world) => !['de', 'es', 'fr', 'gr', 'it'].includes(world))
        .reduce((acc, world) => ({ ...acc, [world]: 'https://help.eduki.com/hc/en-001' }), {})
};

export const HELPCENTER_ARTICLES: NestedRecords<Record> = {
    action: {
        de: 'https://help.eduki.com/hc/de/articles/360020693180-Wie-kann-ich-mein-Material-bearbeiten-z-B-Dateien-austauschen-Angaben-ver%C3%A4ndern-',
        es: 'https://help.eduki.com/hc/es/articles/360020693180--C%C3%B3mo-puedo-editar-mi-material-por-ejemplo-modificar-archivos-o-actualizar-la-descripci%C3%B3n- ',
        fr: 'https://help.eduki.com/hc/fr/articles/360020693180-comment-puis-je-modifier-mon-materiel-par-ex-echanger-un-fichier-actualiser-la-descrip%C3%A4tion'
    },
    earnings: {
        de: 'https://help.eduki.com/hc/de/categories/360003238540-Autor-innen-Honorar',
        es: 'https://help.eduki.com/hc/es/categories/360003238540-Honorarios-de-los-autores-as',
        fr: 'https://help.eduki.com/hc/fr/categories/360003238540-honoraire-de-l-auteur',
        it: 'https://help.eduki.com/hc/it/categories/360003238540-Compenso-per-autori-e-autrici',
        gr: 'https://help.eduki.com/hc/el/categories/360003238540-%CE%91%CE%BC%CE%BF%CE%B9%CE%B2%CE%AE-%CF%83%CF%85%CE%B3%CE%B3%CF%81%CE%B1%CF%86%CE%AD%CF%89%CE%BD'
    },
    upload: {
        de: 'https://help.eduki.com/hc/de/categories/360003252939-Material-hochladen-bearbeiten',
        es: 'https://help.eduki.com/hc/es/categories/360003252939-Subir-y-editar-material',
        fr: 'https://help.eduki.com/hc/fr/categories/360003252939-mettre-en-ligne-editer-ressource'
    }
};

export const contactPhones = {};
